import React, { useState } from 'react';
import axiosInstance from '../api/axiosInstance';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axiosInstance.post('/auth/login', { username, password });

      const { accessToken, refreshToken } = res.data;

      if (accessToken && refreshToken) {
        login({ accessToken, refreshToken });
        setMessage({ type: 'success', text: 'Login erfolgreich!' });
        setTimeout(() => navigate('/'), 500);
      } else {
        setMessage({ type: 'error', text: 'Token-Fehler beim Login.' });
      }

    } catch (err) {
      setMessage({
        type: 'error',
        text: err.response?.data?.error || 'Login fehlgeschlagen.'
      });
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="modern-card p-8 animate-fade-in">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold mb-2 text-primary">Willkommen zurück!</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Melde dich an, um an den Diskussionen teilzunehmen
            </p>
          </div>

          {/* Important Migration Notice */}
          <div className="alert alert-warning mb-6 rounded-xl border-l-4 border-yellow-500 bg-yellow-50 dark:bg-yellow-900/20">
            <div className="flex items-start gap-3">
              <span className="text-xl">⚠️</span>
              <div className="text-sm">
                <h4 className="font-semibold text-yellow-800 dark:text-yellow-200 mb-1">
                  Wichtiger Hinweis zur Forum-Migration
                </h4>
                <p className="text-yellow-700 dark:text-yellow-300">
                  Bei der Forum-Migration wurden alle Benutzernamen in Kleinbuchstaben umgewandelt. 
                  Bitte verwende nur kleine Buchstaben bei der Anmeldung (z.B. "max.mustermann" statt "Max.Mustermann").
Wenn ihr euren ursprünglichen Namen zurückhaben wollt, schreibt uns einfach an redaktion@tivoli12.at.
Solltet ihr bereits mit uns Kontakt gehabt haben bzw. euch bereits angemeldet haben, dann nehmt den dort vergebenen Benutzernamen.                </p>
              </div>
            </div>
          </div>

          {message && (
            <div className={`alert mb-6 rounded-xl ${message.type === 'success' ? 'alert-success' : 'alert-error'}`}>
              <div className="flex items-center gap-2">
                <span className="text-sm">{message.type === 'success' ? '✅' : '❌'}</span>
                <span>{message.text}</span>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                Benutzername
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="input input-bordered w-full rounded-xl border-gray-300 focus:border-primary focus:ring-primary/20 transition-all duration-200"
                placeholder="z. B. max.mustermann"
              />
            </div>
            
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                Passwort
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="input input-bordered w-full rounded-xl border-gray-300 focus:border-primary focus:ring-primary/20 transition-all duration-200"
                placeholder="••••••••"
              />
              <div className="text-right mt-2">
                <Link to="/forgot-password" className="text-sm text-primary hover:text-primary-600 transition-colors duration-200">
                  Passwort vergessen?
                </Link>
              </div>
            </div>

            <button
              type="submit"
              className="glass-btn w-full py-3 px-4 rounded-xl text-white font-semibold text-lg shadow-glow hover:shadow-xl transition-all duration-200"
            >
              Anmelden
            </button>
          </form>

          <div className="mt-8 text-center">
            <p className="text-gray-600 dark:text-gray-400">
              Noch kein Konto? {' '}
              <Link to="/register" className="text-primary hover:text-primary-600 font-semibold transition-colors duration-200">
                Jetzt registrieren
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
